import React from 'react';
import { Link } from 'react-router-dom';

const LoginSignupModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <div className="mt-3 text-center">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Login or Sign Up</h3>
          <div className="mt-2 px-7 py-3">
            <p className="text-sm text-gray-500">
              You need to be logged in to view tool details. Please log in or sign up to continue.
            </p>
          </div>
          <div className="items-center px-4 py-3">
            <Link
              to="/login"
              className="px-4 py-2 bg-blue-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300 mb-3 block"
            >
              Log In
            </Link>
            <Link
              to="/signup"
              className="px-4 py-2 bg-green-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-300 block"
            >
              Sign Up
            </Link>
          </div>
          <button
            onClick={onClose}
            className="mt-3 text-sm text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginSignupModal;
